import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment-timezone";
import Button from "./Button";
import ContentLoader from "react-content-loader";
import EditPatient from "./EditPatient";
import SlotModal from "./SlotModal";
import chat from "../../img/chat.svg";

class HistoryRdvModalContent extends React.Component {
  static defaultProps = {
    hasRdv: false
  };

  constructor(props) {
    super(props);
    this.state = {
      tab: props.tab,
      note: null,
      noteSaved: false,
      noteError: false,
      lastUpdate: props.loading ? null : props.patient.upatedAt
    };
  }
  componentDidMount() {
    if (!this.props.loading) {
      this.props.subscribeToPatient(this.props.patient.id);
    }
  }

  renderStatus = (startTime, status) => {
    let now = moment();
    if (status === "REMOVED") {
      return <span className="tag is-danger">Annulé</span>;
    }
    if (startTime.isAfter(now, "minutes")) {
      return <span className="tag is-warning">A venir</span>;
    }
    if (startTime.isBefore(now, "minutes")) {
      return <span className="tag is-light">Terminé</span>;
    }
  };
  renderWho = (
    startTime,
    status,
    takenBy = "",
    canceledBy = "",
    createdAt,
    updatedAt
  ) => {
    let now = moment();
    if (status === "REMOVED") {
      if (canceledBy && canceledBy.length > 0) {
        return (
          <span
            className="tag is-danger"
            title={updatedAt.format("DD/MM/YYYY [à] HH:mm")}
          >
            {canceledBy}
          </span>
        );
      } else {
        return null;
      }
    }
    if (startTime.isAfter(now, "minutes")) {
      if (takenBy && takenBy.length > 0) {
        return (
          <span
            className="tag is-warning"
            title={createdAt.format("DD/MM/YYYY [à] HH:mm")}
          >
            {takenBy}
          </span>
        );
      } else {
        return null;
      }
    }
    if (startTime.isBefore(now, "minutes")) {
      if (takenBy && takenBy.length > 0) {
        return (
          <span
            className="tag is-light"
            title={createdAt.format("DD/MM/YYYY [à] HH:mm")}
          >
            {takenBy}
          </span>
        );
      } else {
        return null;
      }
    }
  };
  renderRows = () => {
    if (this.props.patient == null) {
      return null;
    }
    return this.props.patient.slots.map((slot, i) => {
      return (
        <tr key={i + "sloth"}>
          <td>{moment(slot.startTime).format("DD/MM/YYYY [à] HH:mm")}</td>
          <td>{slot.slotType.name}</td>
          <td>{this.renderStatus(moment(slot.startTime), slot.status)}</td>
          <td>
            {this.renderWho(
              moment(slot.startTime),
              slot.status,
              slot.takenBy,
              slot.canceledBy,
              moment(slot.createdAt),
              moment(slot.updatedAt)
            )}
          </td>
          <td>
            <p>{slot.comment}</p>
          </td>
        </tr>
      );
    });
  };
  renderHistory = () => {
    return (
      <table className="table is-bordered margin-auto">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Status</th>
            <th>Utilisateur</th>
            <th>Info RdV</th>
          </tr>
        </thead>
        <tbody>{this.renderRows()}</tbody>
      </table>
    );
  };
  renderPaitentData = () => {
    const patientId = this.props.patient.id;
    return (
      <EditPatient
        patientId={patientId}
        handleChangePatient={this.props.handleChangePatient}
        toggleModal={this.props.closeHistoryModal}
      />
    );
  };
  renderRdv = () => {
    return (
      <SlotModal
        userName={this.props.userName}
        event={this.props.event}
        patientId={this.props.patientId}
        isModalOpen={this.props.isModalOpen}
        toggleModal={this.props.closeHistoryModal}
      />
    );
  };
  renderOpenTab = () => {
    switch (this.state.tab) {
      case 0:
        return this.renderHistory();
      case 1:
        return this.renderPaitentData();
      case 2:
        return this.renderRdv();
      default:
        return this.renderHistory();
    }
  };
  changeTab = i => {
    this.setState({ tab: i });
  };

  handlePatientComment = event => {
    let newNote = event.target.value;
    if (newNote === null) {
      newNote = "";
    }
    this.setState(
      {
        note: newNote,
        lastUpdate: moment(),
        noteSaved: false
      },
      () => this.saveComment()
    );
  };
  saveComment = async () => {
    const id = this.props.patient.id;
    const comment = this.state.note;

    await this.props
      .updatePatientComment({
        variables: { id, comment }
      })
      .then(() => {
        //this.props.toggleModal();
        this.setState({
          noteSaved: true
        });
      })
      .catch(e => {
        this.setState({
          noteSaved: false,
          noteError: true
        });
        console.error("update patient", e);
      });
  };

  render() {
    if (this.props.loading) {
      return (
        <div className="modal is-active">
          <div className="modal-background" />
          <div className="modal-card history-modal">
            <header className="modal-card-head" />
            <section className="modal-card-body">
              <ContentLoader type="list" />
            </section>
            <footer className="modal-card-foot">
              <Button text="Retour" onClick={this.props.closeHistoryModal} />
            </footer>
          </div>
        </div>
      );
    }

    let patient = this.props.patient;
    if (patient === null) {
      patient = {};
      patient.nom = "Patient";
      patient.prenom = "effacé";
      patient.matricule = "";
      patient.slots = [];
    }
    let note = this.state.note;
    if (
      this.state.note === null ||
      moment(this.state.lastUpdate).isBefore(moment(patient.updatedAt))
    ) {
      note = patient.comment;
    }

    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-card history-modal">
          <header className="modal-card-head">
            <p className="modal-card-title">
              {patient.nom} {patient.prenom} - {patient.matricule}
            </p>
            <div
              className="is-right is-pulled-right"
              style={{ marginRight: "0.5rem" }}
            >
              <figure className="image is-32x32">
                <a onClick={() => this.props.toggleChatModal(patient)}>
                  <img alt="Doctors" src={chat} />
                </a>
              </figure>
            </div>
          </header>
          <section className="modal-card-body">
            <div className="">
              <label className="label">
                Note:{this.state.noteSaved ? (
                  <span className="blink tag is-success">sauvegardé!</span>
                ) : null}
                {this.state.noteError ? (
                  <span className="is-pulled-right tag is-danger">erreur!</span>
                ) : null}
              </label>
              <div className="control">
                <textarea
                  disabled={this.props.patient === null}
                  className="textarea"
                  cols="5"
                  rows="2"
                  value={
                    note
                    //patient.comment
                    //    this.state.note === null ? patient.comment : this.state.note
                  }
                  onChange={this.handlePatientComment}
                />
              </div>
            </div>
            <div className="tabs is-centered">
              <ul>
                {this.props.hasRdv ? (
                  <li className={this.state.tab === 2 ? "is-active" : ""}>
                    <a onClick={i => this.changeTab(2)}>
                      <span>Rendez-vous</span>
                    </a>
                  </li>
                ) : null}
                {this.props.patient !== null ? (
                  <li className={this.state.tab === 0 ? "is-active" : ""}>
                    <a onClick={i => this.changeTab(0)}>
                      <span>Historique</span>
                    </a>
                  </li>
                ) : null}
                {this.props.patient !== null ? (
                  <li className={this.state.tab === 1 ? "is-active" : ""}>
                    <a onClick={i => this.changeTab(1)}>
                      <span>Données</span>
                    </a>
                  </li>
                ) : null}
              </ul>
            </div>

            <div className="open">{this.renderOpenTab()}</div>
          </section>
          <footer
            className="modal-card-foot"
            style={{ justifyContent: "space-between" }}
          >
            <Button
              className="pull-left"
              text="Sélectionner"
              onClick={() => {
                this.props.handleChangePatient(patient);
                this.props.closeHistoryModal();
              }}
            />
            <Button text="Retour" onClick={this.props.closeHistoryModal} />
          </footer>
        </div>
      </div>
    );
  }
}
const UPDATE_PATIENT_COMMENT = gql`
  mutation updatePatientComment($id: ID!, $comment: String!) {
    updatePatient(id: $id, comment: $comment) {
      id
    }
  }
`;
export default compose(
  graphql(UPDATE_PATIENT_COMMENT, {
    name: "updatePatientComment"
  })
)(HistoryRdvModalContent);



// WEBPACK FOOTER //
// ./src/components/utilities/HistoryRdvModalContent.js